/***
 * Created on 2023/10/3
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import sharedI18n from "common/SharedI18n";
import {I18nextProvider} from "react-i18next";
import IFTTTApprove from '../component/ifttt/ifttt-approve';

import {QueryClient, QueryClientProvider} from "@tanstack/react-query";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false, // default: true
        },
    },
});

const Wrapper = () => {
    return (
        <I18nextProvider i18n={sharedI18n}>
            <QueryClientProvider client={queryClient}>
                <IFTTTApprove />
            </QueryClientProvider>
        </I18nextProvider>
    )
}
export default Wrapper;
